const headerSection = document.querySelector(".header-section");

if (headerSection != null) {
    const header = headerSection.querySelector("#main-header");
    const scrollHeader = headerSection.querySelector(".scroll-header");

    const handleIntersection = (entries, observer) => {
        if (entries[0].isIntersecting){
            scrollHeader.classList.remove("active");
            header.classList.remove("transparent");
        }else{
            scrollHeader.classList.add("active");
            header.classList.add("transparent");
        }
    };

    if(header != null && scrollHeader != null){
        new IntersectionObserver(handleIntersection).observe(header);
    }
}